import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useProperties } from '../hooks/useProperties.js';
import SearchBar from '../components/property/SearchBar.jsx';
import PropertyCard from '../components/property/PropertyCard.jsx';
import Img from '../components/ui/Img.jsx';
import { BRAND, ZONAS } from '../data/constants.js';

const HERO_IMGS = [
  ['photo-1545324418-cc1a3fa10c00','Quilmes — edificio residencial moderno'],
  ['photo-1486406146926-c627a92ad1ab','Arquitectura contemporánea en Zona Sur'],
  ['photo-1568605114967-8130f3a36994','Casa familiar con jardín'],
  ['photo-1502672260266-1c1ef2d93688','Interior luminoso'],
  ['photo-1449034446853-66c86144b0ad','Bernal — vida de barrio'],
];
const img = (id, w = 1900) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

const ACCESOS = [
  { t:'Departamentos', op:'venta', tipo:'departamento', img:'photo-1502672260266-1c1ef2d93688' },
  { t:'Casas',         op:'venta', tipo:'casa',         img:'photo-1568605114967-8130f3a36994' },
  { t:'Terrenos',      op:'venta', tipo:'terreno',      img:'photo-1500382017468-9049fed747ef' },
  { t:'Locales',       op:'alquiler',tipo:'local',      img:'photo-1441986300917-64674bd600d8' },
  { t:'Galpones',      op:'venta', tipo:'galpon',       img:'photo-1586528116311-ad8dd3c8310d' },
  { t:'Emprendimientos',op:'venta',dev:'1',             img:'photo-1486406146926-c627a92ad1ab' },
];

function Hero() {
  const [slide, setSlide] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setSlide(s => (s + 1) % HERO_IMGS.length), 5000);
    return () => clearInterval(t);
  }, []);
  return (
    <section className="hero">
      <div className="hero-media">
        {HERO_IMGS.map(([id, alt], i) => (
          <div key={id} className={"hero-slide" + (i === slide ? " active" : "")} aria-hidden={i !== slide}>
            <img src={img(id)} alt={alt} loading={i === 0 ? "eager" : "lazy"} decoding="async" className="hero-slide-img" draggable={false} />
          </div>
        ))}
        <div className="hero-veil" />
      </div>
      <div className="container hero-in">
        <div className="hero-tag">Inmobiliaria en Quilmes · +{BRAND.years} años de trayectoria</div>
        <h1 className="hero-h1">Encontrá el lugar<br />donde empieza <span className="serif-it">lo próximo.</span></h1>
        <p className="hero-line">Departamentos, casas, terrenos y emprendimientos en Quilmes, Bernal y toda la Zona Sur.</p>
        <div className="hero-search"><SearchBar variant="hero" /></div>
        <div className="hero-trust">
          <div className="ht-item"><b className="tnum">130+</b><span>propiedades activas</span></div>
          <div className="ht-item"><b className="tnum">{BRAND.years}</b><span>años de trayectoria</span></div>
          <div className="ht-item"><b className="tnum">Quilmes</b><span>y toda la Zona Sur</span></div>
        </div>
      </div>
    </section>
  );
}

function Accesos() {
  const nav = useNavigate();
  return (
    <section className="container sec accesos">
      <div className="sec-head"><div><span className="kicker">Por dónde empezar</span><h2 className="sec-title">Explorá por tipo de propiedad</h2></div></div>
      <div className="acc-grid">
        {ACCESOS.map(c => (
          <button key={c.t} className="acc-card" onClick={() => { const p=new URLSearchParams(); p.set('op',c.op); if(c.tipo) p.set('tipo',c.tipo); if(c.dev) p.set('dev',c.dev); nav('/buscar?'+p); }}>
            <div className="acc-media"><Img src={img(c.img,500)} alt={c.t} ratio="5/4" /><div className="acc-veil"/></div>
            <div className="acc-foot"><span>{c.t}</span><span className="acc-arr">→</span></div>
          </button>
        ))}
      </div>
    </section>
  );
}

function Destacadas() {
  const { data, loading } = useProperties({ op: 'venta', limit: 6 });
  const featured = data.filter(p => p.featured).slice(0, 6);
  const show = featured.length > 0 ? featured : data.slice(0, 6);
  return (
    <section className="container sec" id="destacadas">
      <div className="sec-head">
        <div><span className="kicker">Selección Abriola</span><h2 className="sec-title">Propiedades destacadas</h2></div>
        <Link className="sec-link" to="/buscar?op=venta">Ver todas →</Link>
      </div>
      {loading
        ? <div className="feat-grid">{[...Array(6)].map((_,i)=><div key={i} className="sk-card"><div className="skel sk-img"/><div className="sk-lines"><div className="skel sk-l1"/><div className="skel sk-l2"/></div></div>)}</div>
        : <div className="feat-grid">{show.map(p => <PropertyCard key={p.id} p={p} />)}</div>}
    </section>
  );
}

function Zonas() {
  const nav = useNavigate();
  const zonaImgs = ['photo-1449034446853-66c86144b0ad','photo-1480714378408-67cf0d13bc1b','photo-1486325212027-8081e485255e','photo-1494526585095-c41746248156','photo-1448630360428-65456885c650'];
  return (
    <section className="container sec">
      <div className="sec-head"><div><span className="kicker">Conocé el barrio</span><h2 className="sec-title">Explorá por zona</h2></div></div>
      <div className="zona-grid">
        {ZONAS.map((z, i) => (
          <button key={z.slug} className={"zona-card" + (i===0?" zona-lg":"")} onClick={() => nav('/buscar?op=venta&zona='+encodeURIComponent(z.name))}>
            <Img src={img(zonaImgs[i]||zonaImgs[0], 700)} alt={z.name} ratio={i===0?"16/10":"4/3"} />
            <div className="zona-veil"/>
            <div className="zona-info">
              <div className="zona-name">{z.name}</div>
              <span className="zona-count">Ver propiedades →</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}

function Confianza() {
  const nav = useNavigate();
  return (
    <section className="sec confianza-sec">
      <div className="container">
        <div className="confianza">
          <div className="conf-left">
            <span className="kicker">Por qué Abriola</span>
            <h2 className="conf-title">Más de {BRAND.years} años de trayectoria y <span className="serif-it">confianza</span> en Quilmes.</h2>
            <p className="conf-text">Somos una inmobiliaria reconocida por su honestidad, transparencia, profesionalismo y trato personalizado. Ofrecemos asesoramiento con una mirada única y valiosa del mercado local.</p>
            <div className="conf-cta">
              <button className="btn btn-dark" onClick={() => nav('/nosotros')}>Conocé al equipo →</button>
              <a className="btn btn-ghost" href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener">💬 Hablar con un asesor</a>
            </div>
          </div>
          <div className="conf-cards">
            {[['34 años','En el mercado','Desde 1990 acompañando familias e inversores en Quilmes y Zona Sur.'],
              ['100%','Transparencia','Información clara en cada operación, de principio a fin.'],
              ['48 hs','Respuesta promedio','Consultás y te contesta una persona, no un bot.']
            ].map(([n,t,d]) => (
              <div key={t} className="conf-card"><b className="conf-n tnum">{n}</b><div className="conf-cn">{t}</div><p>{d}</p></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function Servicios() {
  const nav = useNavigate();
  return (
    <section className="container sec">
      <div className="serv-grid">
        <div className="serv-card serv-vender">
          <div className="serv-body">
            <span className="serv-kick">Para propietarios</span>
            <h3 className="serv-title">¿Querés vender o alquilar tu propiedad?</h3>
            <p className="serv-text">La publicamos con fotos profesionales, la mostramos a compradores reales y te acompañamos hasta la firma.</p>
            <button className="btn btn-primary" onClick={() => nav('/vender')}>Publicar mi propiedad →</button>
          </div>
          <div className="serv-img"><Img src={img('photo-1560518883-ce09059eeffa',700)} alt="Entrega de llaves" ratio={null} /></div>
        </div>
        <div className="serv-card serv-tasar">
          <div className="serv-body">
            <span className="serv-kick light">Sin compromiso</span>
            <h3 className="serv-title light">Tasá tu propiedad gratis</h3>
            <p className="serv-text light">Te damos un valor de referencia real, basado en lo que se vende hoy en tu zona. En 24 a 48 horas.</p>
            <button className="btn btn-ghost" onClick={() => nav('/vender?modo=tasacion')}>Pedir tasación →</button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <div className="home">
      <Hero /><Accesos /><Destacadas /><Zonas /><Confianza /><Servicios />
      <section className="container sec">
        <div className="home-cta">
          <h2 className="hc-title">Decinos qué buscás.<br /><span className="serif-it">Nosotros lo encontramos.</span></h2>
          <p className="hc-text">Dejanos tus criterios y te avisamos apenas entra algo que encaja. Sin spam, solo lo que te sirve.</p>
          <div className="hc-actions">
            <Link className="btn btn-primary" to="/buscar?op=venta">🔍 Empezar a buscar</Link>
            <a className="btn btn-wa" href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener">💬 Escribinos por WhatsApp</a>
          </div>
        </div>
      </section>
    </div>
  );
}
